import React, { useState } from 'react';
import styled, { css } from 'styled-components';
import { useSelector } from 'react-redux';
import DatePicker from '../../../app/components/datePicker/DatePickerWithRange';
import moment from 'moment';

import StyledSearchInput from '../../../app/components/styledComponents/StyledSearchInput';
import { CustomDropdownStyle } from '../../../app/components/styledComponents/StyledCustomDropdown';
import { StyledCustomButton } from '../../../app/components/styledComponents/StyledCustomButton';
import StyledButton from '../../../app/components/styledComponents/StyledButton';

import CalenderIcon from '../assets/images/calender';
import SendOrder from '../assets/images/sendOrder';

const formatDate = (date = '') =>
  date && moment(date).isValid() ? moment(date).format('DD MMM, YY') : date;

const OrdersHeader = ({
  searchValue,
  setSearchValue,
  navigateToNewOrder = () => {},
  setOrderType = () => {},
}) => {
  const theme = useSelector((state) => state.theme);
  const [selectedOrderType, setSelectedOrderType] =
    useState('Receivered Orders');
  const [startDate, setStartDate] = useState(undefined);
  const [endDate, setEndDate] = useState(undefined);

  const handlePostTypeFilterChange = (postType) => {
    setOrderType(postType);
    setSelectedOrderType(postType);
  };

  const setPickerDate = (date) => {
    setStartDate(date.currentDate);
    setEndDate(date.endDate);
  };

  return (
    <RootContainer>
      <div className="d-flex align-items-center justify-content-between gap-2 mb-3">
        <PageTitle className="mt-1"></PageTitle>
        {selectedOrderType === 'Receivered Orders' && (
          <StyledSearchInput
            className="headerSearch"
            stroke={theme.primary}
            value={searchValue}
            searchIconClassName="search-icon icon-small"
            placeHolder="Search by product name"
            setValue={setSearchValue}
            size="small"
          />
        )}
        {selectedOrderType === 'Receivered Orders' && (
          <div className="d-flex align-items-center flex-row gap-2">
            <DatePickDropdown
              selectedDate={startDate}
              endDate={endDate}
              onChange={setPickerDate}
            />
            <StyledCustomButton.BtnDefault
              size="small"
              borderRadius="4px"
              className="w-100"
            >
              Reset Filter
            </StyledCustomButton.BtnDefault>
          </div>
        )}
        <BtnOutlineDefault
          size="small"
          borderRadius="4px"
          icon={<SendOrder />}
          onClick={navigateToNewOrder}
        >
          Send Order
        </BtnOutlineDefault>
        <SwitchContainer size="small" className="bg-white discussBtn">
          <span
            className={
              selectedOrderType === 'Receivered Orders' ? 'active' : ''
            }
            onClick={() => handlePostTypeFilterChange('Receivered Orders')}
          >
            Received Orders
          </span>
          <span
            className={selectedOrderType === ' Send Orders' ? 'active' : ''}
            onClick={() => handlePostTypeFilterChange(' Send Orders')}
          >
            Send Orders
          </span>
        </SwitchContainer>
        {/* <HeaderFilter>
          <Row>
            <Col md={4}>
            </Col>
            <Col md={2}>
             
            </Col>
            <Col md={2}>
              
            </Col>
          </Row>
        </HeaderFilter> */}
      </div>
    </RootContainer>
  );
};

const DatePickDropdown = ({ selectedDate, endDate, onChange }) => {
  const [showDatePicker, setShowDatePicker] = useState(false);

  const handleChange = (date) => {
    onChange(date);
    setShowDatePicker(false);
  };
  const theme = useSelector((state) => state.theme);

  return (
    <CustomDropdownStyleBox
      show={showDatePicker}
      toggleClassName={'table-dropdown ms-0 table-text'}
      className="custom-drop-down custom-drop-down-width table-dropdown-custom calendar-dropdown topic-dropdown bg-white"
      dropdownToggle={
        <span className="flex-center p-2 w-100 justify-content-between">
          <DropdownPlaceHolder className="me-1 me-lg-2 mb-0 ">
            {selectedDate &&
            moment(selectedDate).isValid() &&
            endDate &&
            moment(endDate).isValid()
              ? `${formatDate(selectedDate)} - ${formatDate(endDate)}`
              : 'Select Date'}
          </DropdownPlaceHolder>
          <CalenderIcon stroke={theme.primary} />
        </span>
      }
      dropDownToggleProps={{
        onClick: () => setShowDatePicker((prev) => !prev),
      }}
      dropdownMenu={
        <DatePicker
          selectedDate={selectedDate}
          selectedEndDate={endDate}
          onChange={handleChange}
        />
      }
    />
  );
};

const RootContainer = styled.div`
  font-family: 'SourceSansPro';
  font-weight: 400;
  p,
  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    font-family: 'SourceSansPro';
    color: ${({ theme }) => theme.secondaryLight};
  }
`;
const CustomDropdownStyleBox = styled(CustomDropdownStyle)`
  .table-dropdown {
    &.menu-toggle {
      height: 32px;
      width: 210px;
    }
  }
`;
// const HeaderFilter = styled.div`
//   .row {
//     margin: 0 -5px;
//     [class*="col-"] {
//       padding: 0 5px;
//     }

//     .menu-toggle {
//       padding: 7px 8px;
//       height: 30px;
//       svg {
//         width: 16px;
//         height: 16px;
//       }
//     }
//   }
// `;

const PageTitle = styled.h5`
  font-size: 18px;
  line-height: 24px;
  color: ${({ theme }) => theme.secondaryLight};
  font-weight: 500;
  flex-grow: 1;
  &.myActivity {
    margin-bottom: 28px;
  }
`;

const DropdownPlaceHolder = styled.h6`
  color: ${({ theme }) => theme.placeholderColor} !important;
`;

const SwitchContainer = styled.div`
  ${({ size }) => css`
    font-size: 18px;
    border: 1px solid ${({ theme }) => theme.lightGray1};
    padding: ${size === 'small' ? '2.5px' : '4px'};
    border-radius: 8px;
    display: flex;
    flex: 1;
    min-width: 250px;
    max-width: 300px;
    span {
      padding: ${size === 'small' ? '2px 20px' : '12px 24px'};
      border-radius: 6px;
      flex: 1;
      text-align: center;
      font-size: 14px;
      color: ${({ theme }) => theme.mainPrimary};
      cursor: pointer;
      @media screen and (max-width: 1700px) {
        padding: ${size === 'small' ? '2px 12px' : '12px 24px'};
      }
      &.active {
        background-color: ${({ theme }) => theme.mainPrimary};
        color: ${({ theme }) => theme.white};
      }
    }
  `}
`;

const BtnOutlineDefault = styled(StyledButton)`
  background-color: transparent;
  border: ${({ size }) => (size === 'xsmall' ? '1px' : '2px')} solid
    ${({ color }) => color};
  color: ${({ color, theme }) => color ?? theme.primary};
  padding: ${({ size }) =>
    size === 'small'
      ? '6px 14px'
      : size === 'xsmall'
      ? '8px 16px'
      : '8px 14px'};
  height: 32px;
  font-weight: 500;
  border-radius: ${({ size }) => (size === 'xsmall' ? '6px' : '8px')};
  font-size: ${({ fontSize, size }) =>
    fontSize ??
    (size === 'small' ? '14px' : size === 'xsmall' ? '12px' : '18px')};
  &:hover,
  &:focus,
  &:active {
    background-color: transparent !important;
    border-color: ${({ color, theme }) => color ?? theme.primary} !important;
    color: ${({ color, theme }) => color ?? theme.primary} !important;
  }
  &:disabled {
    background-color: transparent;
    border-color: ${({ theme }) => theme.primaryLight};
    color: ${({ theme }) => theme.primaryLight};
  }
`;

export default OrdersHeader;
